export default ".img__width {\n  width: 120px;\n}\n\n.text-width {\n  width: 550px;\n  font-size: 12px;\n}\n";